<template>
  <div class="tab-pane-section">
    <div class="tab-pane-header">
      <div class="tab-pane-header__title"> Interests overview </div>
      <div class="tab-pane-header__filter">
        <div class="count-rows">
          Show
          <el-select
              v-model="count"
              @change="chengeCount"
              placeholder=" "
          >
            <el-option
                v-for="item in countOptions"
                :key="item.value"
                :label="item.value"
                :value="item.value"
            >
            </el-option>
          </el-select>
          entries
        </div>
        <el-date-picker
            @change="handleDatePickerChange"
            v-model="dateRange"
            :picker-options="datePickerOptions"
            type="daterange"
            class="date-range-picker"
            format="MM-dd-yyyy" :clearable="false"
            value-format="yyyy-MM-dd"
            size="mini"  align="right"
            start-placeholder="Start Date"
            end-placeholder="End Date">
        </el-date-picker>

        <el-button-group>
          <el-button
              size="mini" v-for="item in suitableFilters"
              v-bind:key="item.filter"
              @click="handleDateRangeFilterChange(item.filter)"
              :class="{'active-filter-btn': dateRangeFilter === item.filter }"
          >
            {{ item.title }}
          </el-button>
        </el-button-group>
        <div class="results-in-page"> Results in page:  {{interestsMeta.to - interestsMeta.from +1}}</div>
        <div class="total-price"> Total price:  ${{interestsTotalPrice}}</div>
      </div>
    </div>
    <div class="tab-pane-body">
      <div class="charts-row">

        <el-table :data="interests" style="width: 100%; min-width:500px;" @sort-change="sort" @filter-change="filterChange" @click="filterChange"
                  :header-cell-class-name="handleTheadAddClass"
        >

          <el-table-column
              prop="utm_funnel"
              label="Funnel"
              column-key="funnel"
              :filters="funnelFilters"
              sort-key="utm_funnel"
              sortable
          > </el-table-column>

          <el-table-column prop="utm_source" label="Source"
                           column-key="source"
                           :filters="sourceFilters"
                           sort-key="utm_source"
                           sortable
          ></el-table-column>

          <el-table-column prop="utm_campaign" label="Campaign"
                           column-key="campaign"
                           :filters="campaignFilters"
                           sort-key="utm_campaign"
                           sortable
          ></el-table-column>

          <el-table-column prop="utm_medium" label="Medium"
                           column-key="medium"
                           :filters="mediumFilters"
                           sort-key="utm_medium"
                           sortable
          ></el-table-column>

          <el-table-column prop="utm_term" label="Term"
                           column-key="term"
                           :filters="termFilters"
                           sort-key="utm_term"
                           sortable
          ></el-table-column>

          <el-table-column prop="utm_content" label="Content"  column-key="content"
                           :filters="contentFilters"
                           sort-key="utm_content"
                           sortable
          ></el-table-column>

          <el-table-column prop="referral" label="Referral"
                           column-key="referral"
                           :filters="referralFilters"
                           sort-key="referral"
                           sortable
          ></el-table-column>

          <el-table-column prop="gclid" label="GCLID"></el-table-column>

          <el-table-column prop="user.email" label="User email"></el-table-column>

          <el-table-column prop="plan.name" label="Plan"  column-key="plan"
                           :filters="planFilters"
                           sort-key="plan"
                           sortable
          >
            <template slot-scope="scope">
              {{ scope.row.plan.name}}
            </template>
          </el-table-column>

          <el-table-column prop="price" label="Price"
                           sort-key="price"
                           sortable
          ></el-table-column>

          <el-table-column prop="subscription.invoice_id" label="Invoice ID"></el-table-column>
        </el-table>
      </div>

      <div class="pagin-wrp">
        <el-pagination
            :background="true"
            layout="prev, pager, next"
            :page-size="1"
            @current-change="chosePage"
            :total="interestsMeta.last_page"
        >
        </el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import analyticFormatData from '@/mixins/analyticFormatData'

export default {
  name: 'PaymentChartsReports',
  mixins: [analyticFormatData],
  components: {},
  data() {
    return {
      dateRange: [],
      dateRangeFilter: 'currentMonth',
      suitableFilters: [
        { filter: 'currentWeek', title: 'Week' },
        { filter: 'currentMonth', title: 'Month' },
        { filter: 'currentYear', title: 'Year' }
      ],
      sortBy:{
        utm_funnel:0,
        utm_source:0,
        utm_campaign:0,
        utm_medium:0,
        utm_term:0,
        utm_content:0,
        referral:0,
        'plan.name':0,
        price:0,

      },
      filterBlock:{},
      datePickerOptions: {
        firstDayOfWeek: 1,
        disabledDate: this.handleMinMaxDatePicker
      },
      page: 1,
      count: 50,
      filterParams: '',
      countOptions: [
        {value: 10},
        {value: 25},
        {value: 50},
        {value: 100},
      ]
    }
  },
  computed: {
    ...mapGetters({
      interests: 'analytic/getInterests',
      interestsMeta: 'analytic/getInterestsMeta',
      interestsTotalPrice: 'analytic/getInterestsTotalPrice',
      funnelFilters : 'analytic/getFunnelFilters',
      planFilters : 'analytic/getPlanFilters',
      sourceFilters : 'analytic/getSourceFilters',
      campaignFilters : 'analytic/getCampaignFilters',
      contentFilters : 'analytic/getContentFilters',
      mediumFilters : 'analytic/getMediumFilters',
      termFilters : 'analytic/getTermFilters',
      referralFilters : 'analytic/getReferralFilters',

    }),

  },
  methods: {
    handleTheadAddClass({ row, column, rowIndex, columnIndex }) {

        if (this.sortBy.hasOwnProperty(column.property) ) {
          if (this.sortBy[column.property] === 0) {
            return ''
          }
          else if (this.sortBy[column.property]=== 1) {
            return  'ascending'
          }
          else if (this.sortBy[column.property] === -1) {
            return 'descending'
          }
            return ''
        }
        return ''
    },
    filterChange(filter) {
      Object.assign(this.filterBlock, filter)
      this.requestTotalPrice()
      this.requestReportsData()
    },

    sort(by) {
      let key  = (typeof by ==="object") ? by.prop : by

      if(by.order=='ascending'){
        this.sortBy[key] = 1
      } else if (by.order=='descending' ) {
        this.sortBy[key] = -1
      } else if (by.order === null ) {
        this.sortBy[key] = 0
      }
      this.requestReportsData()
    },

    requestReportsData() {
      let params = 'sort='
      if (this.sortBy) {
        for (let itm in this.sortBy) {
          if (this.sortBy[itm] === 1) {
            params = `${params}${itm},`
          } else if (this.sortBy[itm] === -1) {
            params = `${params}-${itm},`
          }
        }
      }
      if (params === 'sort=') {
        params = ''
      }
      params = `${params}&page=${this.page}`
      params = `${params}&per_page=${this.count}`
      params = `${params}&start=${this.dateRange[0]}&end=${this.dateRange[1]}`
      if (Object.keys(this.filterBlock).length) {
        Object.entries(this.filterBlock).forEach(([key, value]) => {
          if(value.length === 0){
            return;
          }
          params = `${params}&${key}=`+JSON.stringify(value)
        });
      }
      this.$store.dispatch('analytic/getInterestReport', params)
    },
    requestTotalPrice() {
      let params = `start=${this.dateRange[0]}&end=${this.dateRange[1]}`
      if (Object.keys(this.filterBlock).length) {
        Object.entries(this.filterBlock).forEach(([key, value]) => {
          if(value.length === 0){
            return;
          }
          params = `${params}&${key}=`+JSON.stringify(value)
        });
      }
      this.$store.dispatch('analytic/getInterestsTotalPrice', params)
    },
    handleDatePickerChange(range) {
      this.dateRange = range
      this.requestTotalPrice()
      this.requestReportsData()
    },
    handleDateRangeFilterChange(filter) {
      this.dateRangeFilter = filter
      this.dateRange = [this.date()[filter], this.date().today]
      this.requestTotalPrice()
      this.requestReportsData()
    },
    chosePage (e) {
      this.page = e
      this.requestReportsData()
    },
    chengeCount (e) {
      this.count = e
      this.requestReportsData()
    }
  },
  created() {
    this.dateRange = [this.date()[this.dateRangeFilter], this.date().today]
    this.requestTotalPrice()
    this.requestReportsData()
    this.$store.dispatch('analytic/getPlanFilters')
    this.$store.dispatch('analytic/getFootprintFilters')
  }
}
</script>

<style lang="scss" scoped>
.tab-pane-section {
  padding-bottom: 25px;

  .tab-pane-header {
    border-bottom: 1px solid #E4E7ED;

    &__title {
      padding-bottom: 10px;
      font-size: 28px;
      font-weight: 600;

      @media (max-width: 550px) {
        text-align: center;
      }
    }

    &__filter {
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      padding-bottom: 10px;

      @media (max-width: 550px) {
        flex-direction: column;
        justify-content: center;
        align-items: center;
      }

      .date-range-picker {
        @media (max-width: 550px) {
          width: 75%;
          margin-bottom: 5px;
        }
        @media (min-width: 550px) {
          width: 35%;
        }
        @media (min-width: 768px) {
          width: 45%;
        }
        @media (min-width: 992px) {
          width: 35%;
        }
        @media (min-width: 1100px) {
          width: 25%;
        }
        @media (min-width: 1200px) {
          width: 15%;
        }
      }
    }
  }

  .tab-pane-body {
    padding-top: 10px;

    .charts-row {
      display: flex;
      flex-direction: row;
      justify-content: space-between;

      @media (max-width: 992px) {
        flex-direction: column;
      }
    }
  }
}
.active-filter-btn {
  font-weight: 700;
  color: #3366cd;
  background: #3366cd4f;
}

.count-rows {
  width: 170px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  & > div {
    margin: 0 5px;
  }
}

.total-price{
  padding-top: 4px;
}
</style>
